import { Dialog as BaseDialog } from "@l30/ui";

import type { ComponentProps } from "react";

/**
 * Web wrapper around `@l30/ui`'s native-<dialog> `Dialog`.
 *
 * Adds the `dialog-motion` class so the dialog gets a token-driven
 * enter/exit transition (ADR-0078 X5 — fade + lift on open, reverse on
 * close). The motion itself lives in `styles/globals.css` (`.dialog-motion`,
 * built on `--duration-base` / `--easing-entering` / `--easing-exiting` and
 * `@starting-style` + `allow-discrete` so the native top-layer element
 * animates both directions). It is neutralised by the global
 * `prefers-reduced-motion: reduce` baseline, so reduced-motion users get an
 * instant state change with no extra per-component guard.
 *
 * Everything else is a pass-through: same props, same a11y (focus trap,
 * Escape, × — backdrop does not dismiss). The class is prepended so caller
 * `className` overrides (e.g. `max-w-2xl`) still win via the underlying twMerge.
 */
export function Dialog({ className, ...props }: ComponentProps<typeof BaseDialog>) {
  return (
    <BaseDialog {...props} className={["dialog-motion", className].filter(Boolean).join(" ")} />
  );
}
